var _defs, _g, _g2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCssLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b7893c9e8d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 37.007812 0 L 37.007812 37.007812 L 0 37.007812 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "046b0e2bfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.785156 7.617188 L 29.035156 7.617188 L 29.035156 30.117188 L 8.785156 30.117188 Z M 8.785156 7.617188 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7893c9e8d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 45 L 0 45 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#046b0e2bfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0277bd",
    d: "M 29.035156 7.617188 L 8.785156 7.617188 L 10.574219 27.75 L 18.910156 30.117188 L 27.25 27.75 Z M 29.035156 7.617188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#039be5",
    d: "M 18.910156 9.394531 L 18.910156 28.28125 L 25.582031 26.386719 L 27.070312 9.394531 Z M 18.910156 9.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 24.332031 12.355469 L 18.910156 12.355469 L 18.910156 14.722656 L 21.828125 14.722656 L 21.652344 17.089844 L 18.910156 17.089844 L 18.910156 19.460938 L 21.53125 19.460938 L 21.351562 22.125 L 18.910156 22.953125 L 18.910156 25.441406 L 23.617188 23.898438 L 24.03125 17.089844 Z M 24.332031 12.355469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeeeee",
    d: "M 18.910156 12.355469 L 18.910156 14.722656 L 13.609375 14.722656 L 13.433594 12.355469 Z M 16.171875 17.089844 L 16.289062 19.460938 L 18.910156 19.460938 L 18.910156 17.089844 Z M 16.410156 20.644531 L 14.027344 20.644531 L 14.207031 23.898438 L 18.910156 25.441406 L 18.910156 22.953125 L 16.46875 22.125 Z M 16.410156 20.644531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssLogo);
export default __webpack_public_path__ + "static/media/CssLogo.6df9715a042338175887454e40dd6bae.svg";
export { ForwardRef as ReactComponent };